import { LayerModule } from './.LayerModule.js';
import { LayerModuleFactory } from './.LayerModuleFactory'

export class LayerGroupModule extends LayerModule {
    constructor(terrainView, layerInfo) {
        super(terrainView, layerInfo);

        this.children = this._GetChildren();
    }

    _GetChildren() {
        let rtn = [];

        for (let i in this.layerInfo.Layers) {
            let layer = this.layerInfo.Layers[i];
            rtn.push(LayerModuleFactory.CreateLayer(this.terrainView, layer));
        }

        return rtn;
    }


    async OpenLayer(callback) {
        let promises = [];
        this.children.forEach((child) => {
            promises.push(child.OpenLayer());
        });
        Promise.all(promises).then((results) => {
            let success = true;
            results.forEach((result) => {
                success &= result;
            })
            callback && callback({ success: success });
        });
    }
    async RemoveLayer() {
        this.children.forEach((child) => {
            child.RemoveLayer();
        });
    }
    async SetOpacity(value) {
        this.children.forEach((child) => {
            child.SetOpacity(value);
        });
    }

    async Goto() {
        if (this.layerInfo.Goto) {
            this.terrainView.gotoCamera(
                new window.ov.Camera(
                    new window.Geo3DPoint(this.layerInfo.Goto.Pos),
                    new window.Geo3DPoint(this.layerInfo.Goto.V),
                    new window.Geo3DPoint(this.layerInfo.Goto.Up),
                ), true);
        } else {
            // 定位到第一個子圖層
            this.children.length > 0 && this.children[0].Goto();
        }
    }
}